import { Cell, Pie, PieChart } from "recharts";

// token> utility-gray-300 — shown instead of `colors` when there's no data at all.
const EMPTY_COLOR = "#D5D7DA";

type MiniDonutProps = {
  data: { value: number }[];
  // Fill for each slice, in the same order as `data` — differs by card (e.g.
  // risks: confirmed/dismissed vs resolutions: with-creator/resolved).
  colors: [string, string];
  size?: number;
};

export const MiniDonut = ({ data, colors, size = 60 }: MiniDonutProps) => {
  const total = data.reduce((sum, d) => sum + d.value, 0);
  // A zero total collapses Recharts' Pie into nothing visible — render a full
  // gray ring instead so the donut still appears when there's no data yet.
  const chartData = total === 0 ? [{ value: 1 }] : data;

  return (
    <PieChart width={size} height={size}>
      <Pie data={chartData} dataKey="value" innerRadius={size / 2 - 8} outerRadius={size / 2} strokeWidth={0}>
        {chartData.map((_, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: fixed-size, static slice list
          <Cell key={index} fill={total === 0 ? EMPTY_COLOR : colors[index % colors.length]} />
        ))}
      </Pie>
    </PieChart>
  );
};
